<div class="monthly-report-content">
    <header>
        <img
            src="@/assets/img/BMWGroup_BMW_MINI_Grey-Colour_RGB.png"
            width="500"
            height="79"
            alt="BMW logo" />
        <div>
            <br />
            <p>Recipient: FIRST NAME LAST NAME</p>
            <p>
                Sender: CA-12
                <br />
                Date: {{ fullDate }}
                <br />
                Subject: Monthly report {{ monthAndYearEnglish }} - Customer
                inquiries to the Board of Management & Supervisory Board /
                Monatsreport {{ monthAndYearGerman }} - Kundenanliegen Vorstand
                & ARV
            </p>
        </div>
    </header>
    <main>
        <p>Dear FIRST NAME,</p>
        <p>
            The following is the monthly report for {{ monthAndYearEnglish }} on
            customer concerns addressed to the Board of Management & Supervisory
            Board of BMW AG worldwide.
        </p>
        <div v-html="englishContent"></div>
        <br />
        <img src="@/assets/img/example_chart.png" alt="example chart" />
        <br />
        <div v-html="englishSignature"></div>
        <br />
        <p>Guten Tag FIRST NAME,</p>
        <p>
            im Folgenden erhalten Sie das Monatsreporting {{ monthAndYearGerman
            }} zu den Kundenanliegen, die weltweit an den Vorstand & ARV der BMW
            AG adressiert wurden.
        </p>
        <div v-html="germanContent"></div>
        <br />
        <img src="@/assets/img/example_chart.png" alt="example chart" />
        <br />
        <div v-html="germanSignature"></div>
    </main>
</div>
